import React from 'react';
import './Footer.css';

function Footer() {
  return <footer>Copyright Adam Figueroa 2021</footer>;
}

export default Footer;
